import { Pipe, PipeTransform } from '@angular/core';
import { UsersService } from '../../../modules/users/users.service';

@Pipe({
  name: 'username'
})
export class UsernamePipe implements PipeTransform {
  constructor(private usersService: UsersService) {}

  transform(username: string): string {
    let name = '';
    if (this.usersService.users) {
      const user = this.usersService.users.find((u) => u.username === username);
      name = user ? user.displayName : '-';
    }

    return name;
  }
}
